import { IExportColumnModel } from "../../../../../../shared/models";

export const InboundEmailMessagesExportColumnList: IExportColumnModel[] = [
]